import { z } from "zod";

export const zDisplayId = z.number();

export type ZDisplayId = z.infer<typeof zDisplayId>;
